<template>
  <span v-if="value">
    <p-toolbar-button
      v-if="value.data.video"
      icon="mdi-image-off-outline"
      @click.stop="removeVideo"
      :disabled="changeContentProtection"
      tooltip="Remove Video"
    >
      Remove Video
    </p-toolbar-button>
    <p-toolbar-button
      v-if="value.data.typeAction && !value.data.video"
      icon="mdi-select-off"
      @click.stop="removeVideo"
      tooltip="Remove Action type"
    >
      Remove Action type
    </p-toolbar-button>
  </span>
</template>

<script>
import { PToolbarButton } from "plant-common"

export default {
  name: "VideoToolbar",
  props: ["value"],
  components: {
    PToolbarButton
  },
  methods: {
    removeVideo() {
      this.$set(this.value.data, "video", null)
      this.$set(this.value.data, "typeAction", null)
      this.$set(this.value.data, "subtitles", {})
      this.$set(this.value.data, "avatarJobId", '')
    }
  },
  computed: {
    changeContentProtection() {
      return this.value.protection.data
    }
  }
}
</script>
